export const moneyFormatter = (value: number | undefined = 0): string =>
  value === 0 ? "$ 0.00" :`$ ${value?.toFixed(2)}`

